import axios from "../../common"

export const ApiListPermissions = async () => {
    return axios.get("/auth/permissions/list/", {withCredentials: true})
}